import { createContext, useEffect, useState } from "react";

export const ReportContentContext = createContext();

const initialReportContentState = {
  seminarsWorkshops: "",
  conference: "",
  facultyParticipation: "",
  booksPublished: "",
  patentsObtained: "",
  equipmentsAdded: "",
  financialAssistance: "",
  researchAndDevelopment: "",
  newLaboratoryCenter: "",
  listOfPapersPublished: ""
};

export const SEMINARS_WORKSHOPS = "seminarsWorkshops";
export const CONFERENCE = "conference";
export const FACULTY_PARTICIPATION = "facultyParticipation";
export const BOOKS_PUBLISHED = "booksPublished";
export const PATENTS_OBTAINED = "patentsObtained";
export const EQUIPMENTS_ADDED = "equipmentsAdded";
export const FINANCIAL_ASSISTANCE = "financialAssistance";
export const RESEARCH_AND_DEVELOPMENT = "researchAndDevelopment";
export const NEW_LABORATORY_CENTER = "newLaboratoryCenter";
export const LIST_OF_PAPERS_PUBLISHED = "listOfPapersPublished";


export const ReportContentContextProvider = ({ children }) => {
  const [content, setContent] = useState(initialReportContentState);
  const setSubTitle = (subTitle, subTitleContent) => {
    setContent((content) => {
      const newContent = {
        ...content,
      };
      newContent[subTitle] = subTitleContent;
      return newContent;
    });
  };

  const getSubTitle = (subTitle) => {
    return content[subTitle];
  };

  useEffect(() => {
    // Get the content from the backend and use setContent to set the same
    console.log(content);
  }, [content]);

  return (
    <ReportContentContext.Provider
      value={{ content, setContent, setSubTitle, getSubTitle }}
    >
      {children}
    </ReportContentContext.Provider>
  );
};
